(function () {
    'use strict';

    angular
      .module('services.env', [])
      .factory('env', service);

    service.$inject = ['$location'];

    function service($location) {
        var devHost     = 'localhost';
        var currentHost = $location.host();

        return {
            isDev: currentHost === devHost
        };
    }
})();